import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    IconButton,
    Button,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
// import AddPreferredPartner from "../../Modals/addpreferredpartner";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const ViewSubscription = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    // Example subscription details
    const subscriptionDetails = {
        type: "Premium",
        name: "Pro Plan",
        validity: "90 Days",
        price: "$29.99",
        benefits: ["All Premium Features", "Priority Support", "Ad-Free Experience"],
        status: true,
        createdDate: "10 Oct 2025",
    };

    // Example user data
    const [userData, setUserData] = useState([
        {
            id: "#USR001",
            name: "John Doe",
            email: "john@example.com",
            phone: "+91 9876543210",
            status: "Ongoing",
        },
        {
            id: "#USR002",
            name: "Alice Smith",
            email: "alice@example.com",
            phone: "+91 9123456789",
            status: "Expired",
        },
        {
            id: "#USR003",
            name: "Bob Williams",
            email: "bob@example.com",
            phone: "+91 9988776655",
            status: "Ongoing",
        },
    ]);
    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const [courierPartners, setCourierPartners] = useState([
        { id: 1, title: "DHL Express" },
        { id: 2, title: "FedEx" },
        { id: 3, title: "BlueDart" },
    ]);


    return (
        <>
            <div className="main_title">
                <h1>Subscription Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/subscriptions")}>
                        Manage Subscriptions
                    </button>{" "}
                    - View Subscription
                </p>
            </div>
            
                <div className="cards">
                    <div className="view_page">
                        <div className="gap_p">
                            <div className="w_33">
                                <h6>Subscription Type</h6>
                                <p>{subscriptionDetails.type}</p>
                            </div>

                            <div className="w_33">
                                <h6>Subscription Name</h6>
                                <p>{subscriptionDetails.name}</p>
                            </div>

                            <div className="w_33">
                                <h6>Validity</h6>
                                <p>{subscriptionDetails.validity}</p>
                            </div>

                            <div className="w_33">
                                <h6>Price</h6>
                                <p>{subscriptionDetails.price}</p>
                            </div>

                            <div className="w_33">
                                <h6>Status</h6>
                                <p>
                                    <SwitchToggle />
                                </p>
                            </div>

                            <div className="w_33">
                                <h6>Created Date</h6>
                                <p>{subscriptionDetails.createdDate}</p>
                            </div>

                            <div className="w_100">
                                <h6>Benefits</h6>
                                <ul className="inline_tags">
                                    {subscriptionDetails.benefits.map((b, i) => (
                                        <li key={i}>{b}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>


                    <div className="title_inner"><h2>Users</h2></div>




                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sr. No.</TableCell>
                                    <TableCell>User Details</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {userData
                                    .filter((user) =>
                                        user.name.toLowerCase().includes(searchTerm.toLowerCase())
                                    )
                                    .map((user, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>
                                                <div className="user_block">
                                                    <figure>
                                                        <img
                                                            src="/static/images/user_placeholder.png"
                                                            alt="User"
                                                        />
                                                    </figure>
                                                    <p>
                                                        <b>{user.name}</b>
                                                        {user.email}
                                                        <br />
                                                        {user.phone}
                                                    </p>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                {user.status}
                                            </TableCell>

                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </div>
           
            {/* <AddPreferredPartner open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} /> */}

        </>
    );
};

export default ViewSubscription;
